module.exports = __webpack_public_path__ + "img/磕头.669e3563.gif";